import {
    CHECK_LOGIN_STATUS,
    FETCH_USER_DATA
} from '../ActionTypes'

const API_URL = process.env.API_URL

const checkLoginStatus = (json) => {
    return {
        type: CHECK_LOGIN_STATUS,
        payload: json
    }
}

const updateUserData = (json) => {
    return {
        type: FETCH_USER_DATA,
        payload: json
    }
}

const fetchUserData = (token) => {
    return dispatch => {
        return fetch(`${API_URL}/auth/profile`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`
                }
            })
            .then(response => response.json())
            .then(json => dispatch(updateUserData(json.result)))
    }
}

export const authenticate = (token) => {
    return dispatch => {
        return fetch(`${API_URL}/auth/authenticate`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`
                }
            })
            .then(response => response.json())
            .then(json => {
            	if (json.success)
            		dispatch(fetchUserData(token))
            	dispatch(checkLoginStatus(json))
            })
    }
}



// WEBPACK FOOTER //
// ./src/Router/RouterActions.js